import React, { useEffect, useRef, useState } from 'react';
import { APPS } from '../data/apps';
import { cx } from '../utils/cx';
import styles from './HomeScreenUI.module.css';

// Fake iOS 26-style home screen rendered inside the center hero phone.
// `playing` (= the hero fan's `state.in`) gates the whole "widget pops open
// → text/ring animate in → icons settle" choreography — see
// HomeScreenUI.module.css for the keyframes/timeline.
export default function HomeScreenUI({ playing = false }) {
  const [count, setCount] = useState(4);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!playing) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    setCount(0);
    const delayId = setTimeout(() => {
      const t0 = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - t0) / 950);
        setCount(Math.round(4 * (1 - Math.pow(1 - k, 3))));
        if (k < 1) rafRef.current = requestAnimationFrame(step);
      };
      rafRef.current = requestAnimationFrame(step);
    }, 1600);

    return () => {
      clearTimeout(delayId);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [playing]);

  const [cadet, fridge, habitBranches] = APPS;
  const gridApps = [
    { app: cadet, label: 'Cadet Pilot' },
    { app: fridge, label: 'Fridge' },
    { app: habitBranches, label: 'Habits' },
  ];
  const placeholders = (count) =>
    Array.from({ length: count }, (_, i) => (
      <span key={i} className={styles.hsApp}>
        <i className={styles.ph} />
      </span>
    ));

  return (
    <div className={styles.hs}>
      <div className={styles.sb}>
        <span>9:41</span>
        <span className={styles.ic}>
          <i style={{ width: 3, height: 5 }} />
          <i style={{ width: 3, height: 7 }} />
          <i style={{ width: 3, height: 9 }} />
          <i style={{ width: 3, height: 11 }} />
          <i style={{ width: 20, height: 10, borderRadius: 3, marginLeft: 4 }} />
        </span>
      </div>

      <div className={cx(styles.hsW, playing && styles.playing)}>
        <span className={styles.rg} />
        <div className={styles.tx}>
          <small>CADET PILOT</small>
          <b>Daily Goal</b>
          <span>
            <em className={styles.cnt}>{count}</em> / 5 sessions
          </span>
        </div>
      </div>

      <div className={styles.hsGrid}>
        {gridApps.map(({ app, label }, i) => (
          <span key={app.id} className={cx(styles.hsApp, styles[`a${i + 1}`], playing && styles.playing)}>
            <i>{app.icon && <img src={app.icon} alt="" />}</i>
            {label}
          </span>
        ))}
        {placeholders(5)}
      </div>

      <span className={styles.hsSearch}>⌕ Search</span>
      <div className={styles.hsDock}>{placeholders(4)}</div>
    </div>
  );
}
